import BaseNotificationHandler from './baseHandler.js';

/**
 * Default Notification Handler
 * Fallback handler for unknown notification types
 */
class DefaultHandler extends BaseNotificationHandler {
  // Inherits all default implementations from BaseNotificationHandler
}

export default DefaultHandler;

